import { render } from "./Envios.vue?vue&type=template&id=8f1f0532"
import script from "./Envios.vue?vue&type=script&lang=js"
export * from "./Envios.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__